<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>
            <my-header h1="Course Subject Detail"></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div v-for="item in data">
              <div style="margin-top:10px">
                <strong>{{item.ProgramName}}</strong>
              </div>
              <table width="100%" class="table table-bordered table-sm table-striped table-color " style="font-size: 12px;border-collapse: collapse;" border="1">
                <thead>
                  <tr>
                    <th class="bg" align="center">Sr. No.</th>
                    <th class="bg">Course Code</th>
                    <th class="bg">Course Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i,index) in item.Courses">
                    <td align="center"> {{index+1}}</td>
                    <td> {{i.CourseCode}}</td>
                    <td> {{i.CourseName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
        faculty: ''
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        axios.post('/api/DCApi/CourseDetailPrint')
          .then(function (res) {
            vm.data = res.data.final;
          })
      }
    }
  })
</script> 
<style>
  .bg {
    background-color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/DC/CourseDetailPrint.vue